// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import * as PowerControlUnitsActions from '../../redux/actions/powerControlUnits.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import PowerControlUnitEventsList from './PowerControlUnitEventsList.jsx';
import { formatPcuEventTypeLabel } from './powerControlUnitEventFormatters.js';

@connect(state => ({
  powerControlUnits: state.powerControlUnits,
  selectedPCU: state.powerControlUnits.selectedPCU,
}))
class PowerControlUnitEventsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingInitial: false,
      isAppending: false,
    };
  }

  getPcuId(props = this.props) {
    const { powerControlUnitId, selectedPCU } = props;
    if (powerControlUnitId !== undefined && powerControlUnitId !== null) {
      return powerControlUnitId;
    }
    if (selectedPCU && selectedPCU.id) {
      return selectedPCU.id;
    }
    return null;
  }

  componentDidMount() {
    this.onFetchEvents(0);
  }

  componentWillReceiveProps(nextProps) {
    const oldPcuId = this.getPcuId(this.props);
    const newPcuId = this.getPcuId(nextProps);
    const { autoFetchOnFilterChange = true } = this.props;
    const oldFilters = this.props.powerControlUnits.events.filters;
    const newFilters = nextProps.powerControlUnits.events.filters;
    const filtersChanged = !_.isEqual(oldFilters, newFilters);
    if (newPcuId !== oldPcuId || (autoFetchOnFilterChange && filtersChanged)) {
      this.onFetchEvents(0, nextProps);
    }
  }

  async onFetchEvents(page = 0, props = this.props) {
    const { dispatch } = props;
    const pcuId = this.getPcuId(props);
    if (!pcuId) {
      return;
    }

    this.setState({ isLoadingInitial: true, isAppending: false });
    try {
      dispatch(PowerControlUnitsActions.resetPowerControlUnitEventsPaginationData());
      await dispatch(PowerControlUnitsActions.fetchPowerControlUnitEvents(pcuId, page, false));
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      this.setState({ isLoadingInitial: false });
    }
  }

  async onAppendEvents(page) {
    const { dispatch, powerControlUnits } = this.props;
    const pcuId = this.getPcuId();
    const pagination = powerControlUnits.events.pagination || {};
    const last = pagination.last === true;

    if (!pcuId || _.isNaN(page) || last || this.state.isAppending || this.state.isLoadingInitial) {
      return;
    }

    this.setState({ isAppending: true });
    try {
      await dispatch(PowerControlUnitsActions.fetchPowerControlUnitEvents(pcuId, page, true));
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      this.setState({ isAppending: false });
    }
  }

  getFilteredEvents(events) {
    const { searchText } = this.props;
    if (!searchText || !events) {
      return events || [];
    }
    const searchLower = searchText.toLowerCase();
    return events.filter((event) => {
      const eventTypeLabel = formatPcuEventTypeLabel(event.eventType).toLowerCase();
      return (event.eventType && event.eventType.toLowerCase().includes(searchLower))
        || eventTypeLabel.includes(searchLower)
        || (event.state && event.state.toLowerCase().includes(searchLower))
        || (event.outcome && event.outcome.toLowerCase().includes(searchLower));
    });
  }

  render() {
    const {
      powerControlUnits: { events: { content: events, pagination } },
      listStyle,
    } = this.props;
    const { isLoadingInitial, isAppending } = this.state;
    const pcuId = this.getPcuId();

    const last = pagination && pagination.last === true;

    if (!pcuId) {
      return <EmptyView entityName="events" />;
    }

    if (isLoadingInitial && (!events || events.length === 0)) {
      return <ListLoadingView />;
    }

    const filteredEvents = this.getFilteredEvents(events);

    return (
      <PowerControlUnitEventsList
        events={filteredEvents}
        pagination={pagination || { number: 0, last: true }}
        viewLoading={isLoadingInitial || isAppending}
        listStyle={listStyle}
        hasMore={!last && !isAppending}
        onLoadMore={page => this.onAppendEvents(page)}
      />
    );
  }
}

export default PowerControlUnitEventsView;
